{
  "item-name": {
    "t-shirt-united-athle-5001": {
      "short": "Tシャツ",
      "long": "Tシャツ（United Athle 5001 5.6オンス）",
      "details": "United Athle 5001 5.6オンス"
    },
    "long-sleeve-t-shirt-united-athle-5011": {
      "short": "ロングスリーブTシャツ",
      "long": "ロングスリーブTシャツ（United Athle 5011 5.6オンス 1.6インチリブ）",
      "details": "United Athle 5011 5.6オンス 1.6インチリブ"
    },
    "sweat-united-athle-5044": {
      "short": "スウェット",
      "long": "スウェット（United Athle 5044 10オンス 裏パイル）",
      "details": "United Athle 5044 10オンス 裏パイル"
    }
  },
  "item-size": {
    "s": "S",
    "m": "M",
    "l": "L",
    "xl": "XL"
  },
  "item-color": {
    "white": "ホワイト",
    "black": "ブラック",
    "oatmeal": "オートミール",
    "indigo": "インディゴ",
    "natural": "ナチュラル",
    "darkbrown": "ダークブラウン",
    "ivygreen": "アイビーグリーン",
    "ash": "アッシュ",
    "offpink": "オフピンク",
    "mixgray": "ミックスグレー",
    "navy": "ネイビー"
  },
  "screen-color": {
    "white": "ホワイト",
    "black": "ブラック",
    "darkgray": "ダークグレー",
    "gray1": "グレー1",
    "gray2": "グレー2",
    "lightgray1": "ライトグレー1",
    "lightgray2": "ライトグレー2",
    "winered": "ワインレッド",
    "radish": "ラディッシュ",
    "red": "レッド",
    "hotpink": "ホットピンク",
    "pink": "ピンク",
    "lightpink": "ライトピンク",
    "brick": "レンガ",
    "orange": "オレンジ",
    "sunflower": "サンフラワー",
    "yellow": "イエロー",
    "lightyellow": "ライトイエロー",
    "straw": "ストロー",
    "goldyellow": "ゴールドイエロー",
    "darkgreen": "ダークグリーン",
    "green": "グリーン",
    "lime": "ライム",
    "yellowgreen": "イエローグリーン",
    "pastelgreen": "パステルグリーン",
    "mintgreen": "ミントグリーン",
    "olive": "オリーブ",
    "mossgreen": "モスグリーン",
    "grassgreen": "グラスグリーン",
    "greentea": "グリーンティー",
    "palegreen": "ペールグリーン",
    "ocean": "オーシャン",
    "emeraldgreen": "エメラルドグリーン",
    "navy": "ネイビー",
    "reflexblue": "リフレックスブルー",
    "royalblue": "ロイヤルブルー",
    "turquoise": "ターコイズ",
    "lightblue": "ライトブルー",
    "saxe": "サックス",
    "violet": "バイオレット",
    "purple": "パープル",
    "lavender": "ラベンダー",
    "lilac": "ライラック",
    "darkbrown": "ダークブラウン",
    "lightbrown": "ライトブラウン",
    "apricot": "アプリコット",
    "cream": "クリーム",
    "offwhite": "オフホワイト",
    "rosepink": "ローズピンク",
    "salmonpink": "サーモンピンク",
    "fresh": "フレッシュ",
    "beige": "ベージュ",
    "fluorescentorange": "蛍光オレンジ",
    "fluorescentyellow": "蛍光イエロー",
    "fluorescentgreen": "蛍光グリーン",
    "fluorescentblue": "蛍光ブルー",
    "fluorescentpink": "蛍光ピンク",
    "gold": "ゴールド",
    "silver": "シルバー"
  },
  "printing-method": {
    "inkjet": "ホワイトインクジェットプリント",
    "screen": "シルクスクリーン印刷"
  },
  "print-place": {
    "front": "前面",
    "back": "背面"
  },
  "shipping-method": {
    "yupack": "ゆうパック",
    "yupacket": "ゆうパケット",
    "yamato": "ヤマト宅配便",
    "nekopos": "ネコポス",
    "sagawa": "佐川急便"
  }
}
